import { useSyncExternalStore } from 'react';

/** Subscribe to a CSS media query. */
export const useMediaQuery = (query: string) =>
  useSyncExternalStore(
    (callback) => {
      const watcher = window.matchMedia(query);
      watcher.addEventListener('change', callback);

      return () => {
        watcher.removeEventListener('change', callback);
      };
    },
    () => window.matchMedia(query).matches,
  );

/** Below this width the stock layout is used (it has its own hamburger / bottom navigation). */
export const THREEPANE_MIN_WIDTH = 760;
/** At and above this width all three columns are shown at the same time. */
export const THREEPANE_FULL_WIDTH = 1280;

export type ThreePaneTier = 'full' | 'tablet';

export const useThreePaneTier = (): ThreePaneTier =>
  useMediaQuery(`(min-width: ${THREEPANE_FULL_WIDTH}px)`) ? 'full' : 'tablet';

/** Whether the viewport is wide enough for the three-pane layout at all. */
export const useThreePaneWideEnough = () =>
  useMediaQuery(`(min-width: ${THREEPANE_MIN_WIDTH}px)`);
